import { RefObject, useState } from 'react'
import { IUseRangeSlider } from './types'

export const useRangeSlider: IUseRangeSlider = (min = 0, max = 999999) => {
  const [values, setValues] = useState({
    min,
    max,
  })

  return {
    values,
    setValues,
  }
}

export const onEnter = (
  ref: RefObject<HTMLTextAreaElement>,
  afterChange?: (min: number, max: number) => void,
  minValue?: number,
  maxValue?: number
): void => {
  if (ref.current && afterChange) {
    // eslint-disable-next-line no-param-reassign
    ref.current.onkeydown = (e) => {
      if (e.keyCode === 13) {
        if (minValue) {
          afterChange(minValue, Number(ref.current?.value))
        }

        if (maxValue) {
          afterChange(Number(ref.current?.value), maxValue)
        }
      }
    }
  }
}
